module.exports = __webpack_public_path__ + "static/media/linkedin-icon.0f997669.svg";